import { useEffect, type FC } from 'react';
import type { ProductVariantCardFragment } from '@boc/framework/saleor-graphql';

import { useAnalytics } from '../context';
import type { TVariantCardPermalink } from '../types';

interface TrackViewVariantListProps {
  variants: ProductVariantCardFragment[];
  itemUrl: TVariantCardPermalink;
  listId: string;
  listName: string;
}

export const TrackViewVariantList: FC<TrackViewVariantListProps> = ({
  variants,
  itemUrl,
  listId,
  listName,
}) => {
  const tracker = useAnalytics();

  useEffect(() => {
    if (variants.length > 0) {
      tracker.trackViewVariantList({ variants, itemUrl, listId, listName });
    }
  }, []);

  return null;
};
